import { Space } from "antd";
import React, { useEffect } from "react";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import { SectionCardHeading } from "./style";
import "./style.css";
import { withScroll } from "../../../HOC/withScroll";
import { useSelector } from "react-redux";
import { Wrapper } from "../../../Constant";
import { savePaymentGateway } from "../../../Utils";

const ThankyouPage = () => {
  const { transactionId, name, isUpiAsba  , successfullPaymentMode, savePaymentDetails  } = useSelector((state) => state.policyDetails);
  const belstarAvailable = useSelector((state) => state.belstarAvailable);
  const { isVendorBelstar, uniqueIdentifier } = belstarAvailable;
  const belstarData = useSelector((state) => state.belstarDetails);
  let { memberEmail, memberMobile } = belstarData;
  const dd = useSelector((state) => state);
   let {
        policyNumber,
        proposalNumber,
    } = savePaymentDetails;

  useEffect(() => {
    const reqObj = {
      "paymentGatewayMode": successfullPaymentMode,
      "uniqueIdentifier": policyNumber !== "" ? policyNumber : proposalNumber,
      "orderId": transactionId
    }
    savePaymentGateway(reqObj)
  }, [])

  return (
    <>
      <div className="container">
        <Wrapper>
          <SectionCardWrapper>
            <div className="container">
              <Space direction="vertical">
                <SectionCardHeading>Hi {name}!</SectionCardHeading>
                {!isVendorBelstar ? <label className={"cls_mghuntl9_8135f1"}>
                  {`You have successfully Paid the Amount`}
                  <br />
                  <br />
                  {!isUpiAsba && `Your transactionId is -: ${transactionId}`}
                </label> :
                  <label className={"cls_mghuntl9_8135f1"}>
                    {`Thank you for your payment. Your transaction has been successfully processed. `}
                    <br />
                    <br />
                    {"Your Certificate of Insurance will be sent to "}
                    {memberEmail ? <b>{memberEmail}</b> : ""}
                    {memberEmail && memberMobile !== null ? " or your mobile number " : ""}
                    {<b>{memberMobile}</b>}
                    {" shortly"}
                  </label>}
              </Space>
            </div>
          </SectionCardWrapper>
        </Wrapper>
      </div>
    </>
  );
};

export default withScroll(ThankyouPage);
